import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {TypedForm, TypedFormOwnControls} from '../../../common/form-types';
import {ColumnsManagerModule} from '../../../components/columns-manager';
import {TABLE_COLUMNS_RESIZING_MODE_SWITCH_CONFIG} from '../../../components/tables/table';
import {L10nModule} from '../../../components/translate';
import {WidgetImplSettingsComponentBase} from '../../components/widget-impl-settings-component-base';
import {DEX_DEV_RATES_TABLE_COLUMNS_DEF, DexDevRatesTableColumnConfig} from '../dex-dev-rates-table';
import {DexDevRatesWidget} from '../dex-dev-rates-widget';
import {DexDevRatesWidgetSettings} from './dex-dev-rates-widget-settings';

interface SettingsFormValue {
    title: string;
    columns: DexDevRatesTableColumnConfig[];
}

@Component({
    selector:    'dex-dev-rates-widget-settings',
    imports: [
        L10nModule,
        ReactiveFormsModule,
        ColumnsManagerModule
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './dex-dev-rates-widget-settings.component.html'
})
export class DexDevRatesWidgetSettingsComponent
    extends WidgetImplSettingsComponentBase<DexDevRatesWidget> {

    @Input()
    public override widget: DexDevRatesWidget;

    public form: TypedForm<SettingsFormValue>;

    public readonly tableColumnsDef = DEX_DEV_RATES_TABLE_COLUMNS_DEF;

    public readonly TABLE_COLUMNS_RESIZING_MODE_SWITCH_CONFIG = TABLE_COLUMNS_RESIZING_MODE_SWITCH_CONFIG;

    private readonly widgetImpl = this.widget.implementationInstance;

    protected override buildForm(): void {
        const settings: DexDevRatesWidgetSettings = this.widgetImpl.settings;

        this.form = new FormGroup({
            title: this.createTitleFormControl(settings),
            columns: this.createColumnsSettingsFormControl(settings)
        } satisfies TypedFormOwnControls<SettingsFormValue>);
    }

    private createColumnsSettingsFormControl(settings: DexDevRatesWidgetSettings): FormControl {
        const control: FormControl = new FormControl(settings.columns);

        this.bindControlToSettings({control, settingsFieldName: 'columns'});

        return control;
    }

}
